interface SanitizeHostnameOptions {
  toLowerCase?: boolean
}

export const sanitizeHostname = (
  hostname: string | undefined | null,
  options: SanitizeHostnameOptions = {},
) => {
  const { toLowerCase = true } = options
  const normalized = (hostname || '').split(':')[0] || ''
  return toLowerCase ? normalized.toLowerCase() : normalized
}
